export default "__VITE_ASSET__DqUi3Z7O__"